import ModalMailingListItemController from '~/pages/account/mailing/modal/modal-mailing-list-item.controller';
import templateModalMailingListItem from '~/pages/account/mailing/modal/modal-mailing-list-item.html';
import APIV5 from '~/models/api';
import Node from '~/scripts/services/model/node';
import accountMailingListQuery from './account-mailing-list.query.json';

/* globals Knitiv */

export default class AccountMailingController {
	/* @ngInject */
	/**
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 * @param {import('~/scripts/services/model/node-service').NodeService} NodeService
	 * @param {import('~/scripts/services/model/user').UserModel} User
	 */
	constructor(
		$rootScope,
		$timeout,
		$uibModal,
		NodeService,
		User,
	) {
		this.$rootScope = $rootScope;
		this.$timeout = $timeout;
		this.$uibModal = $uibModal;
		this.NodeService = NodeService;
		this.User = User;

		/** @type {any[]} */
		this.mailingList = [];

		this.mailingListLoading = false;

		(async () => this.loadMailingList())();
	}

	async addMailingList() {
		await this.editMailingList(null, this.NodeService.create('K_NODE;MAILINGLIST'));
		return this.loadMailingList();
	}

	/**
	 * @param {Event | null} event
	 * @param {any} mailingList
	 * @returns {Promise<any>}
	 */
	async deleteMailingList(event, mailingList) {
		event?.preventDefault();
		await this.NodeService.delete(mailingList.kid);
		return this.loadMailingList();
	}

	/**
	 * @param {Event | null} event
	 * @param {any} nodeMailingList
	 * @returns {Promise<any>}
	 */
	async editMailingList(event, nodeMailingList) {
		event?.preventDefault();

		if (!(nodeMailingList instanceof Node)) {
			// eslint-disable-next-line no-param-reassign
			nodeMailingList = await this.NodeService.load(nodeMailingList.kid);
			// nodeMailingList.create = true;
		}

		try {
			/**
			 * @type {{
			 *   nodes: Node[]
			 *   itemsToRemove: import('@knitiv/api-client-javascript').KNode[]
			 * }}
			 */
			const result = await this.$uibModal.open({
				animation:    true,
				controller:   ModalMailingListItemController,
				controllerAs: '$ctrl',
				template:     templateModalMailingListItem,
				resolve:      {
					nodeMailingList: () => nodeMailingList,
				},
			}).result;

			if (result) {
				await this.NodeService.set(result.nodes);
				if (result.itemsToRemove.length > 0) {
					await APIV5.instance.objectDelete({
						items: result.itemsToRemove,
					});
				}
				return this.loadMailingList();
			}
		}
		catch (error) {
			if (error !== 'cancel') {
				console.error(error);
			}
		}

		return false;
	}

	async loadMailingList() {
		this.mailingListLoading = true;
		try {
			// const result = await API.instance.objectList({
			// 	class_kid: 'K_NODE;MAILINGLIST',
			// });

			// TODO: je ne sais pas pourquoi j'ai une TS2322 ici
			const response = await APIV5.instance.queryExec({
				// @ts-ignore
				query: accountMailingListQuery,
			}, {
				id: 'account-mailing.load-mailing-list',
			});
			// const response = await API.instance.mfSuggestion2('K_NODE;KSYSQUERY', { nocache: true });
			this.$timeout(() => {
				this.mailingList = response.result.rows;
				this.mailingListLoading = false;
			});
		}
		catch (error) {
			this.$timeout(() => {
				this.mailingList.length = 0;
				this.mailingListLoading = false;
			});
			console.error(error);
		}
	}

	/**
	 * @param {string | any[]} cells
	 * @returns {'PRIVATE' | 'PUBLIC' | 'CUSTOM' | null}
	 */
	mailingGetType(cells) {
		/** @type {'PRIVATE' | 'PUBLIC' | 'CUSTOM' | null} */
		let type = null;
		if (
			cells.length === 1
			&& cells[0].kid === this.$rootScope.context?.profil.kid
		) {
			type = 'PRIVATE';
		}
		else if (
			cells.length === 1
			&& cells[0].kid === 'K_NODE;KR_WF_TOUS'
		) {
			type = 'PUBLIC';
		}
		else if (cells.length > 0) {
			type = 'CUSTOM';
			// this.mailing.role = cells.map(droit => ({ kid: droit.role.kid, name: droit.role.name }));
		}

		return type;
	}
}
